/**
 * 로봇 칸의 한국어 표기 정본(2026-10-09) — 로봇 목록 배지(콘솔 StatusPill)와 기준일 마감본 CSV(회계용)가
 * 같은 말을 쓰게 한 곳에 둔다. 종전엔 화면 파일마다 따로 적혀 있었다. 상태는 `ROBOT_STATUS_LABELS`(enums).
 */
/** 위치 — 로봇 목록의 위치 배지와 같은 말. AS_CENTER 는 옛 데이터용(선택지에서는 숨김). */
export const ROBOT_LOCATION_LABELS = {
    RESEARCH: '연구소',
    FACTORY: '공장',
    WAREHOUSE: '창고',
    CUSTOMER_SITE: '고객 현장',
    AS_CENTER: 'AS 센터',
    DISPOSAL: '폐기',
};
/** 자산 확인 상태 — 로봇 목록·상세의 배지와 같은 말. */
export const ROBOT_VERIFICATION_LABELS = {
    CONFIRMED: '확인됨',
    PHANTOM: '미확인 자산',
    TENTATIVE_OWNERSHIP: '소유 재검토',
    MISSING_SERIAL: 'SN 소실',
};
/** 소유 법인. */
export const OWNER_ENTITY_LABELS = {
    BEYOND_HONEYCOMB: '비욘드허니컴',
    HONEYCOMB_ROBOTICS: '허니컴로보틱스',
};
/**
 * 회계번호 체계 — 회계번호의 모양으로 가른 묶음(docs/plan/04-business-rules.md BR-ACC-01).
 * UNKNOWN 은 '미지정' — 아직 가르지 않았다는 뜻이지 회계번호가 틀렸다는 뜻이 아니다(9/30 에는 전 로봇이 이 값).
 */
export const ACCOUNTING_SCHEME_LABELS = {
    GRILLX_24: '그릴X 24년 체계',
    GEN1_D2_25: 'GEN1 디자인2 25년 체계',
    GEN2_25: 'GEN2 25년 체계',
    OPERATING_LEASE: '운용리스 자산',
    LEGACY_SILJUNG: '실증 그릴 로봇',
    DEPRECIATED_MARKED: '감가 완료 표시',
    UNKNOWN: '미지정',
};
/** 구분(판매/구독) — 목록 화면 '구분' 칸과 같은 판정의 한국어. 미배정은 빈 칸. */
export const ROBOT_CONTRACT_KIND_LABELS = {
    SALE: '판매',
    SUBSCRIPTION: '구독',
    AMBIGUOUS: '확인 필요',
};
/** 구분 값이 어디서 왔는가 — 자동 파생 / 관리자 수동 정정. */
export const ROBOT_CONTRACT_KIND_SOURCE_LABELS = {
    AUTO: '자동',
    MANUAL: '수동 정정',
};
//# sourceMappingURL=robot-labels.js.map